import React from 'react';

const LABELS = { de: 'DE', en: 'EN' };

/** Small pill indicating which language a localized field is currently editing. */
const LangTag = ({ lang }) => (
  <span className={`lang-tag${lang === 'en' ? ' lang-tag-en' : ''}`}>
    {LABELS[lang] || String(lang).toUpperCase()}
  </span>
);

export default LangTag;
